import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material'
import HandBagIcon from '../../../../assets/icons/Handbag.svg'
import TicketIcon from '../../../../assets/icons/Ticket.svg'
import CustomInput from '../../../../components/muiComponents/customInput/CustomInput'
import { courseApiSlice } from '../../../../features/course/courseSlice'
import { icon, option, optionWrapper, text } from '../style'

const GetCourseOptions = () => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const [promocode, setPromocode] = useState<string>('')
    const [openDialog, setOpenDialog] = useState(false)
    const [enrollToCourse, { isLoading }] =
        courseApiSlice.useEnrollToCourseByPromocodeMutation()

    const handleEnrollToCourse = async () => {
        try {
            await enrollToCourse({ promocode }).unwrap()
            toast.success(formatMessage({ id: 'enrolledToCourse' }))
            setOpenDialog(false)
        } catch (e) {}
    }

    return (
        <Box sx={optionWrapper}>
            <Box
                sx={option}
                onClick={() => navigate('/buy-course')}
            >
                <Box sx={text}>
                    <img
                        src={HandBagIcon}
                        style={icon}
                    />
                    {formatMessage({ id: 'purchaseCourse' })}
                </Box>
            </Box>

            <Box
                sx={option}
                onClick={() => setOpenDialog(true)}
            >
                <Box sx={text}>
                    <img
                        src={TicketIcon}
                        style={icon}
                    />
                    {formatMessage({ id: 'enterCode' })}
                </Box>
            </Box>

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>{formatMessage({ id: 'enterCode' })}</DialogTitle>

                <DialogContent>
                    <CustomInput
                        onChange={(
                            event: React.ChangeEvent<HTMLInputElement>,
                        ) => {
                            setPromocode(event.target.value)
                        }}
                        placeholder={formatMessage({ id: 'enterCode' })}
                        fullWidth
                    />
                </DialogContent>

                <DialogActions style={{ padding: '0 24px 12px 0' }}>
                    <Button
                        onClick={() => setOpenDialog(false)}
                        disabled={isLoading}
                    >
                        {formatMessage({ id: 'cancel' })}
                    </Button>

                    <Button
                        variant="contained"
                        disabled={isLoading}
                        onClick={handleEnrollToCourse}
                    >
                        {isLoading ? (
                            <CircularProgress
                                size={20}
                                style={{ marginRight: '8px' }}
                            />
                        ) : (
                            formatMessage({ id: 'submit' })
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default GetCourseOptions
